import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { SlotsControlForm } from './SlotsControlForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allActivities, selectedResort } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj miejsca' : 'Dodaj miejsca '} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <SlotsControlForm
                data={data}
                submitCallback={submitCallback}
                handleClose={handleClose}
                allActivities={allActivities}
                selectedResort={selectedResort}
              />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
